import React, { Component } from 'react';
import Style from './index.less';
import classNames from 'classnames';
import i18n from '@i18next/i18n';
import { IPictureModelProps } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/picture-model-props.interface';
import omit from 'lodash/omit';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { IElementModelProps } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/element-model-props.interface';

interface PresetMenuProps {
    pictureProps: IPictureModelProps;
    onPresetStyleClick: (value) => void;
    onPresetStyleMouseEnter: (value) => void;
    onPresetStyleMouseLeave: () => void;
}

interface IPictureColorPresetItem {
    key: string;
    title: string,
    alpha?: number;
}

const TransparencyStyleList: IPictureColorPresetItem[] = [
    {
        key: 'alpha-1',
        title: i18n.t('透明度{0}%', { 0: 0 }),
        alpha: 1,
    },
    {
        key: 'alpha-0.85',
        title: i18n.t('透明度{0}%', { 0: 15 }),
        alpha: 0.85,
    },
    {
        key: 'alpha-0.7',
        title: i18n.t('透明度{0}%', { 0: 30 }),
        alpha: 0.7,
    },
    {
        key: 'alpha-0.5',
        title: i18n.t('透明度{0}%', { 0: 50 }),
        alpha: 0.5,
    },
    {
        key: 'alpha-0.35',
        title: i18n.t('透明度{0}%', { 0: 65 }),
        alpha: 0.35,
    },
    {
        key: 'alpha-0.2',
        title: i18n.t('透明度{0}%', { 0: 80 }),
        alpha: 0.2,
    },
    {
        key: 'alpha-0.05',
        title: i18n.t('透明度{0}%', { 0: 95 }),
        alpha: 0.05,
    },
];


export default class PictureTransparencyPresetMenu extends Component<PresetMenuProps> {
    public constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div className={Style.container}>
                <div className={Style['preset-type-title']}>{i18n.t('透明度')}</div>
                <div className={Style['preset-collection']}>
                    {TransparencyStyleList.map(item => this.renderPresetIcon(item))}
                </div>
            </div>
        );
    }

    private renderPresetIcon(item: IPictureColorPresetItem) {
        const src = this.getSrc(this.props.pictureProps);
        const isSelected = this.isSelected(item);
        const softEdgeItemClass = classNames({
            [Style['preset-collection-item']]: true,
            [Style['preset-item-selected']]: isSelected,
        });
        return (
            <div
                key={item.key}
                className={softEdgeItemClass}
                onMouseEnter={() => this.handlePresetIconMouseEnter(item)}
                onClick={() => this.handlePresetIconClick(item)}
                onMouseLeave={() => this.handlePresetIconMouseLeave()}
            >
                <Tooltip placement={['top', 'right']} title={i18n.t(item.title)}>
                    <div className={Style['preset-icon']}>
                        <img src={src} style={{ opacity: item.alpha }}/>
                    </div>
                </Tooltip>
            </div>
        );
    }

    private isSelected(item) {
        const value = this.props.pictureProps.style || {};
        return !Object.keys(item).some(key => typeof value[key] !== 'undefined' && item[key] !== value[key]);
    }

    private handlePresetIconMouseEnter = (item: IPictureColorPresetItem) => {
        this.props.onPresetStyleMouseEnter(omit(item, ['key', 'title']));
    };

    private handlePresetIconClick = (item: IPictureColorPresetItem) => {
        this.props.onPresetStyleClick(omit(item, ['key', 'title']));
    };

    private handlePresetIconMouseLeave = () => {
        this.props.onPresetStyleMouseLeave();
    };

    private getSrc = (props: IElementModelProps | IPictureModelProps) => {
        if ('src' in props) {
            return props.src;
        }
        return props.style?.fillBackground?.image?.src;
    };
}
